import i18n from "@/i18ns/i18n";
import commonFunction from "@/commons/commonFunction";
import store from "@/stores/store";

/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
    /**
     * Đối tượng cache lại các component popup
     */
    _components = {};

    /**
     * Danh sách các popup đang hiển thị
     * key: tên popup
     * value: instance
     */
    _visible = {};

    /**
     * Ẩn tất cả các popup đang hiển thị đi
     */
    hideAll() {
        const me = this;
        let names = [];
        for (let i in me._visible) {
            names.push(i);
        }
        names.forEach(item => {
            me.hide(item);
        });
    }

    /**
     * Ẩn popup theo tên nếu đang hiển thị
     */
    hide(name) {
        let popup = this._visible[name];
        if (popup) {
            delete this._visible[name];
            if (typeof popup.beforeHide === "function") {
                popup.beforeHide();
            }
            // if (typeof popup.close === "function") {
            //     popup.close();
            // }
        }
    }

    /**
     * Hiển popup chi tiết
     * @param {Object} owner Form/Component gọi show
     * @param {EnumQuickAdd} type Loại popup
     * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
     * @param {Object} options Các biến hỗ trợ điều khiền luồng
     * @public
     */
    show(owner, type, data, options) {
        var me = this,
            component = me._components[type];

        if (!type) {
            throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
        } else {
            var promise;
            options = options || {};
            me._customParam(type, options);
            if (!component) {
                component = me._loadComponent(type);

                if (component) {
                    promise = new Promise((resolve, reject) => {
                        var fnSuccess = function (module) {
                            if (module) {
                                var popupModule = module.default;
                                if(process.env.NODE_ENV === 'development'){
                                    console.log(popupModule.__file);
                                }
                                if (popupModule) {
                                    me._components[type] = popupModule;
                                    me._show(type, popupModule, owner, options, data).then(
                                        record => {
                                            resolve(record);
                                        },
                                        function (error) {
                                            reject(error);
                                        }
                                    );
                                }
                            }
                        };

                        var fnFailure = function (error) {
                            commonFunction.handleException(error);
                            reject(error);
                        };

                        component.then(fnSuccess, fnFailure);
                    });
                }
            } else {
                promise = me._show(type, component, owner, options, data);
            }

            return promise;
        }
    }

    /**
     * Lấy ra options để truyền sang form dialog quickAdd cho một số tình huống đặc thù
     */
    _customParam(type, options) { }

    /**
     * Show form popup
     */
    _show(type, component, owner, options, data) {
        const me = this;
        var promise = new Promise((resolve, reject) => {
            if (component) {
                let frm;
                // pvduy thêm đoạn này để xử lý có thể truyền data vào một popup đang show (Đã trao đổi với SA a BNĐức)
                if (options.single && me._visible[type]) {
                    frm = me._visible[type];
                    options._reshow = true;
                    frm.show(data, options);
                    return;
                }

                frm = commonFunction.renderDynamicElement(
                    document.body,
                    component,
                    owner, {
                    i18n,
                    store,
                },true
                );
                if (frm) {
                    //tracking để quản lý các popup đang hiển thị
                    me._visible[type] = frm;
                    if (owner) {
                        frm.$$router = owner.$router;
                        frm.$$route = owner.$route;
                    }

                    //khi đóng form chi tiết -> lắng nghe để giải phóng
                    frm.$on("close", function () {
                        //để timeout để đảm bảm event chạy xong hết rồi mới giải phóng form
                        setTimeout(() => {
                            document.body.removeChild(frm.$el);
                            delete frm.ownerForm;
                            delete frm.editMode;
                            delete frm.active;
                            delete frm.$$router;
                            delete frm.$$route;

                            frm.$destroy();
                            delete me._visible[type];
                        }, 10);

                        //gọi hàm close nếu có
                        if (options && typeof options.close === "function") {
                            options.close();
                        }
                    });

                    if (options) {
                        //sự kiện dùng cho base quickSearch
                        if (typeof options.searchSubmit === "function") {
                            frm.$on("searchsubmit", options.searchSubmit);
                        }

                        if (typeof options.submit === "function") {
                            frm.$on("submit", options.submit);
                        }
                    }

                    frm.ownerForm = owner;
                    if (options.mode) {
                        frm.editMode = options.mode;
                    }

                    if (typeof (frm.active) === 'boolean') {
                        frm.active = true;
                    }
                    if (typeof frm.show === "function") {
                        frm.show(data, options);
                    }
                }
            }
        });

        return promise;
    }

    /**
     * render element vào target element
     * @param {HTMLElement} target vùng target để render
     * @param {Object} owner Form/Component gọi show
     * @param {EnumQuickAdd} type Loại popup
     * @param {} data Các trường thông tin mặc định cho đối tượng được mở form lên
     * @param {Object} options Các biến hỗ trợ điều khiền luồng
     * @public
     */
    append(target, owner, type, data, options, isAppendTarget) {
        var me = this,
            component = me._components[type];

        if (!type) {
            throw new Error("DEV: Vui lòng xem lại cấu hình popup.");
        } else {
            var promise;
            options = options ? options : {};
            me._customParam(type, options);

            if (!component) {
                component = me._loadComponent(type);

                if (component) {
                    promise = new Promise((resolve, reject) => {
                        var fnSuccess = function (module) {
                            if (module) {
                                var popupModule = module.default;
                                if (popupModule) {
                                    me._components[type] = popupModule;
                                    me._append(target, popupModule, owner, options, data, isAppendTarget).then(
                                        record => {
                                            resolve(record);
                                        },
                                        function (error) {
                                            reject(error);
                                        }
                                    );
                                }
                            }
                        };

                        var fnFailure = function (error) {
                            commonFunction.handleException(error);
                            reject(error);
                        };

                        component.then(fnSuccess, fnFailure);
                    });
                }
            } else {
                promise = me._append(target, component, owner, options, data, isAppendTarget);
            }

            return promise;
        }
    }

    /**
     * render show
     */
    _append(target, component, owner, options, data, isAppendTarget) {
        var promise = new Promise((resolve, reject) => {
            if (owner && component) {
                let frm = commonFunction.renderDynamicElement(
                    target,
                    component,
                    owner, {
                    i18n,
                    store
                },
                    isAppendTarget
                );
                if (frm) {
                    //khi đóng form chi tiết -> lắng nghe để giải phóng
                    frm.$on("close", function () {
                        if (typeof options.close === "function") {
                            options.close();
                        }else{
                            commonFunction.focusFirstControlInput(owner.$el)
                        }

                        target.removeChild(frm.$el);
                        frm.$destroy();
                    });

                    //submit
                    if (typeof options.submit === "function") {
                        frm.$on("submit", options.submit);
                    }

                    frm.ownerForm = owner;
                    if (options.mode) {
                        frm.editMode = options.mode;
                    }

                    if (typeof (frm.active) === 'boolean') {
                        frm.active = true;
                    }
                    if (typeof frm.show === "function") {
                        frm.show(data, options);
                    }
                }
            }
        });

        return promise;
    }

    /**
     * Thực hiện load các component quickAdd theo type
     * @privates
     */
     _loadComponent(type) {
        var component;
        return component;
    }
}

export default new PopupUtil();